<template>
  <TheNavbar />

  <div v-if="userProfile" class="mt-5 mb-5">

    <div class="row justify-content-center mb-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <ProfileChangePassword :userProfile="userProfile" />
        <ProfileDeleteAccount :userProfile="userProfile" />
      </div>
    </div>

  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import ProfileChangePassword from '@/components/ProfileChangePassword'
import ProfileDeleteAccount from '@/components/ProfileDeleteAccount'
export default {
  components: {
    TheNavbar,
    ProfileChangePassword,
    ProfileDeleteAccount
  },
  computed: {
    userProfile () {
      return this.$store.getters.getUserProfile
    }
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  }
}
</script>
